var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllusFittings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "240px",
    height: "240px",
    viewBox: "0 0 240 240",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "illus_no_test_events_IB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-37.5%",
    y: "-120.0%",
    width: "175.0%",
    height: "340.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,20 L100,20 L100,75.9934444 C100,78.206204 98.2004701,80 96.0026765,80 L3.99732351,80 C1.78966269,80 0,78.2043192 0,75.9934444 L0,20 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-7.0%",
    y: "-8.3%",
    width: "114.0%",
    height: "123.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.290196078   0 0 0 0 0.6  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "-2.48949813e-15%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF4FA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,3.99922997 C0,1.79051625 1.79952991,0 3.99732351,0 L96.0026765,0 C98.2103373,0 100,1.79246765 100,3.99922997 L100,20 L0,20 L0,3.99922997 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-7.0%",
    y: "-25.0%",
    width: "114.0%",
    height: "170.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.290196078   0 0 0 0 0.6  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "114.573303%",
    x2: "50%",
    y2: "7.4636489%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF4FA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-8",
    cx: 21,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-43.8%",
    y: "-31.2%",
    width: "187.5%",
    height: "187.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-9"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.290196078   0 0 0 0 0.6  0 0 0 0.07 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.0932174,9 L9.53321739,9 C8.24950725,9 7.08823188,9.756 6.57344928,10.9264615 L4.83617391,14.8781538 C4.47165217,15.708 4.85565217,16.6753846 5.69228986,17.0326154 L5.82585507,17.0889231 C6.69217391,17.4581538 7.69113043,17.028 8.01298551,16.1473846 L9.27536232,12.6923077 L13.9130435,12.6923077 L11.1304348,19.1538462 L8.34782609,29.3076923 L1.63988406,29.3076923 C0.734608696,29.3076923 0,30.0378462 0,30.9396923 L0,32.2910769 C0,33.1929231 0.734608696,33.9230769 1.63988406,33.9230769 L9.62782609,33.9230769 C10.8197101,33.9230769 11.8947246,33.2123077 12.3575652,32.1193846 L15.3043478,25.1538462 L21.8175072,38.0649231 C22.0883478,38.6353846 22.6652754,39 23.2997101,39 L25.28,39 C26.4728116,39 27.2658551,37.7732308 26.7724058,36.6932308 L19.4782609,21.4615385 L21.7971014,15 L24.3524638,18.2695385 C24.7884058,18.828 25.4590145,19.1538462 26.1685797,19.1538462 L30.3601159,19.1538462 C31.2663188,19.1538462 32,18.4236923 32,17.5218462 C32,16.6209231 31.2663188,15.8898462 30.3601159,15.8898462 L27.3623188,15.8898462 L23.6735072,10.4086154 C23.0808116,9.528 21.158029,9 20.0932174,9 Z",
    id: "path-10"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-10.9%",
    y: "-8.3%",
    width: "121.9%",
    height: "123.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-11"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.290196078   0 0 0 0 0.6  0 0 0 0.07 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illus_no_test_events_IB"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illus_no_test_events"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    fill: "#EEF4FA",
    cx: 120,
    cy: 120,
    r: 120
  }), /*#__PURE__*/React.createElement("g", {
    id: "illus_test_event",
    transform: "translate(70.000000, 82.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1",
    fillOpacity: 0.2,
    fill: "#004A99",
    filter: "url(#filter-1)",
    points: "10 92 90 92 90 67 10 67"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-6)",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-4)",
    fillRule: "evenodd",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    fill: "url(#linearGradient-7)",
    x: 10,
    y: 30,
    width: 40,
    height: 40,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5360582,53 L61.991155,53 C60.8914705,53 60,52.1132936 60,51.0018986 L60,46.9981014 C60,45.8945804 60.8896739,45 61.991155,45 L75.0802141,45 L69.1956529,39.1154388 C68.2545271,38.1743131 68.2530745,36.6498994 69.1985958,35.7043781 L70.3340713,34.5689026 C71.2768224,33.6261515 72.8090811,33.6299087 73.745132,34.5659597 L84.6258304,45.446658 C84.8031146,45.5494011 84.9700754,45.6765916 85.1217728,45.828289 L86.2572483,46.9637645 C86.7445649,47.4510811 86.9803352,48.0921697 86.965559,48.7279221 C86.9803352,49.3636744 86.7445649,50.004763 86.2572483,50.4920796 L85.1217728,51.6275551 C84.9700754,51.7792525 84.8031146,51.9064431 84.6258304,52.0091861 L73.745132,62.8898845 C72.8090811,63.8259354 71.2768224,63.8296926 70.3340713,62.8869415 L69.1985958,61.751466 C68.2530745,60.8059447 68.2545271,59.2815311 69.1956529,58.3404053 L74.5360582,53 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-7)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "man",
    transform: "translate(16.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-9)",
    xlinkHref: "#path-8"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-11)",
    xlinkHref: "#path-10"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-10"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllusFittings);
export default __webpack_public_path__ + "static/media/illus-fittings.23d8797d298facf5aeb00fc7e56a3e5e.svg";
export { ForwardRef as ReactComponent };